import { Link } from 'react-router-dom';
import '../styles/Page.css';

export default function Skills() {
  return (
    <div className="page-wrapper">
      <Link to="/" className="page-back">\u2190 Back to Home</Link>
      <h1 className="page-title">💡 Skills</h1>
      <p className="page-subtitle">Languages, frameworks, tools, and technologies I work with.</p>
      <div className="placeholder-box">
        <div className="icon">💡</div>
        <p>Content for <strong>Skills</strong> goes here.</p>
        <p style={{ marginTop: 8, fontSize: '0.8rem' }}>Fill this section with your own information.</p>
      </div>
    </div>
  );
}
